"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAliasColors = void 0;
var footerBackground_1 = require("./footerBackground");
var getDisabledBg = function (globals, brand) {
    var colors = globals.colors;
    switch (brand) {
        case 'agco':
            return colors.primary.grays[400];
        case 'fendt':
            return colors.grays[300];
        default:
            return colors.primary.grays[200];
    }
};
var getRedShades = function (globals) {
    var colors = globals.colors;
    return {
        redShade200: colors.secondary.shades[200],
        redShade400: colors.secondary.shades[400],
        redShade600: colors.secondary.shades[600],
        redShade800: colors.secondary.shades[800],
    };
};
var getGreenShades = function (globals) {
    var colors = globals.colors;
    return {
        greenShade200: colors.secondary.shades[200],
        greenShade400: colors.secondary.shades[400],
        greenShade600: colors.secondary.shades[600],
        greenShade800: colors.secondary.shades[800],
    };
};
var getGrayShades = function (globals) {
    var colors = globals.colors;
    return {
        grayShade200: colors.primary.grays[200],
        grayShade400: colors.primary.grays[400],
        grayShade600: colors.primary.grays[600],
        grayShade800: colors.primary.grays[800],
    };
};
var getLightAndDisabledTextColors = function (globals, brand) {
    var colors = globals.colors;
    return {
        light: colors.grays[50],
        disabled: colors.grays[brand === 'fendt' ? 500 : 400],
    };
};
var getNeuGrays = function (globals) {
    var colors = globals.colors;
    return {
        neuGray50: colors.grays[50],
        neuGray100: colors.grays[100],
        neuGray200: colors.grays[200],
        neuGray300: colors.grays[300],
        neuGray400: colors.grays[400],
        neuGray500: colors.grays[500],
        neuGray600: colors.grays[600],
        neuGray700: colors.grays[700],
        neuGray800: colors.grays[800],
        neuGray900: colors.grays[900],
    };
};
var getStatusColors = function (globals) {
    var colors = globals.colors;
    return {
        lightSuccess: colors.success[100],
        success: colors.success[500],
        darkSuccess: colors.success[900],
        lightWarning: colors.warning[100],
        warning: colors.warning[500],
        darkWarning: colors.warning[900],
        lightError: colors.error[100],
        error: colors.error[500],
        darkError: colors.error[900],
        lightInfo: colors.info[100],
        info: colors.info[500],
        darkInfo: colors.info[900],
    };
};
var getAliasColors = function (globals, brand) {
    var colors = globals.colors;
    return {
        footerBackground: (0, footerBackground_1.getFooterBackground)(colors, brand),
        bg: __assign(__assign(__assign(__assign(__assign(__assign(__assign({ primary: colors.primary.brand, secondary: colors.secondary.brand }, getRedShades(globals)), getGreenShades(globals)), { white: colors.primary.white, dark: colors.primary.black }), getGrayShades(globals)), { light: colors.grays[50], disabled: getDisabledBg(globals, brand) }), getNeuGrays(globals)), getStatusColors(globals)),
        text: __assign(__assign(__assign(__assign(__assign(__assign(__assign({ primary: colors.primary.brand, secondary: colors.secondary.brand }, getRedShades(globals)), getGreenShades(globals)), { default: colors.primary.black, white: colors.primary.white }), getGrayShades(globals)), getLightAndDisabledTextColors(globals, brand)), getNeuGrays(globals)), getStatusColors(globals)),
        icon: __assign(__assign(__assign(__assign(__assign(__assign(__assign({ primary: colors.primary.brand, secondary: colors.secondary.brand }, getRedShades(globals)), getGreenShades(globals)), { default: colors.primary.black, white: colors.primary.white }), getGrayShades(globals)), getLightAndDisabledTextColors(globals, brand)), getNeuGrays(globals)), getStatusColors(globals)),
        stroke: __assign(__assign(__assign(__assign(__assign(__assign(__assign({ primary: colors.primary.brand, secondary: colors.secondary.brand }, getRedShades(globals)), getGreenShades(globals)), { default: colors.primary.black, white: colors.primary.white }), getGrayShades(globals)), getLightAndDisabledTextColors(globals, brand)), getNeuGrays(globals)), getStatusColors(globals)),
    };
};
exports.getAliasColors = getAliasColors;
